// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import React from "react"
import { IonPage } from "@ionic/react"
import useSession from './useSession'
import { UnsupportedDevice } from "./UnsupportedDevice"
import './SectionPage.scss'
import { useScreenOrientation } from "./useScreenOrientation"


interface SectionPageProps {
  children?: React.ReactNode
  hideMenu?: boolean
}


const SectionPage: React.FC<SectionPageProps> = (props) => {
  const session = useSession()
  const {classes} = useScreenOrientation()
  const pageStyle: any = {
    top: "var(--page-header-height)",
  }
  let content = props.children
  if (!!session.isUnsupportedDevice()) {
    content = (<UnsupportedDevice/>)
  }
  if (!!props.hideMenu) {
    classes.push("main-menu-disabled")
  }
  return (
    <IonPage
      className={classes.join(" ")}
      id="main-content"
      style={pageStyle}
    >
      {content}
    </IonPage>
  )
}


export default SectionPage